
import { DatePicker, parseToDateString, getEndDateOfMonth, getDateOfWeek } from '../date-picker/index.js';
import { loadTemplate, templateStore } from '../template/index.js';
import { loadUserAvailability, getCoachBookings } from './ajax.js';
import bookingStore from './store.js';
import { getEnabledDatesInMonth, isDateFullyBooked, timeToMinutes, add30Minutes, isSlotBooked, minutesToTime, isSlotPast } from './utilities.js';

async function renderDatePicker() {
	const coachId = document.getElementById('coach-id')?.value;
	if (!coachId) {
		return;
	}
	await loadUserAvailability(coachId);
	const today = new Date();
	const endDate = getEndDateOfMonth(today.getMonth(), today.getFullYear());
	await getCoachBookings(coachId, parseToDateString(today), parseToDateString(endDate));
	// Reschedule: min date is tomorrow (24h rule)
	const isReschedule = !!document.getElementById('reschedule-session-id');
	const minDate = new Date();
	if (isReschedule) {
		minDate.setDate(minDate.getDate() + 1);
	}
	minDate.setHours(0, 0, 0, 0);

	new DatePicker({
		container: document.getElementById('student-booking-date-picker'),
		minDate,
		onDateChange: (date) => {
			renderTimeSlot(date);
			bookingStore.setSelectedDate(date);
		},
		renderStatusOfDates: (currentMonth, currentYear) => {
			const availability = bookingStore.getCoachAvailability();
			const bookings = bookingStore.getBookings() || [];
			const statusOfDates = {};

			// 1. Lấy tất cả các ngày được enable trong tháng
			const enabledDates = getEnabledDatesInMonth(availability, currentMonth, currentYear);

			// 2. Với mỗi ngày, check xem có full booking không
			enabledDates.forEach((date) => {
				const dayStr = parseToDateString(date);
				const isFull = isDateFullyBooked(date, availability, bookings);
				statusOfDates[dayStr] = isFull ? 'disabled' : 'default';
			});
			return statusOfDates;
		},
		afterInit(date) {
			renderTimeSlot(date);
			bookingStore.setSelectedDate(date);

			const loadingSpinner = document.querySelectorAll('.spinner-loading');
			if (loadingSpinner.length > 0) {
				loadingSpinner.forEach((spinner) => {
					spinner.style.display = 'none';
				});
			}
		}
	});
}

async function renderTimeSlot(selectedDate) {
	if (!selectedDate) {
		return;
	}
	if (!bookingStore.coachAvailability) {
		return;
	}
	if (!bookingStore.bookings) {
		return;
	}

	const container = document.getElementById('time-slot');
	if (!container) return;
	const morning = container.querySelector('#morning');
	const afternoon = container.querySelector('#afternoon');
	if (!morning || !afternoon) {
		return;
	}
	morning.innerHTML = '';
	afternoon.innerHTML = '';
	await Promise.all([
		loadTemplate('booking/time-slot.ejs'),
		loadTemplate('booking/time-slot-item.ejs'),
	]);

	const filteredSlots = [];

	const dateOfWeek = getDateOfWeek(selectedDate);
	const dayAvailability = bookingStore.coachAvailability[dateOfWeek];
	if (dayAvailability && dayAvailability.enabled) {

		const startMinutes = timeToMinutes(dayAvailability.start_time);
		const endMinutes = timeToMinutes(dayAvailability.end_time);

		// Filter slots based on start and end time
		for (let i = startMinutes; i < endMinutes; i += 30) {
			filteredSlots.push(minutesToTime(i));
		}

	}

	const isReschedule = !!document.getElementById('reschedule-session-id');

	function isSlotDisabled(date, time) {
		if (isReschedule) {
			// Reschedule: slot must be >= 24h from now
			const slotStart = new Date(`${parseToDateString(date)}T${time}:00`);
			const minTime = new Date(Date.now() + 24 * 60 * 60 * 1000);
			return slotStart < minTime;
		}
		return isSlotPast(date, add30Minutes(time));
	}

	const morningSlots = filteredSlots.filter(
		(time) => parseInt(time.split(':')[0]) < 12,
	);
	const afternoonSlots = filteredSlots.filter(
		(time) => parseInt(time.split(':')[0]) >= 12,
	);

	if (morningSlots.length > 0) {
		morningSlots.forEach((time) => {
			// eslint-disable-next-line no-undef
			const html = ejs.render(templateStore.get('booking/time-slot-item.ejs'), {
				time,
				endTime: add30Minutes(time),
				booked: isSlotBooked(selectedDate, time, add30Minutes(time), bookingStore.getBookings()),
				past: isSlotDisabled(selectedDate, time),
			});
			morning.insertAdjacentHTML('beforeend', html);
		});
	}

	// Render afternoon slots
	if (afternoonSlots.length > 0) {
		afternoonSlots.forEach((time) => {
			// eslint-disable-next-line no-undef
			const html = ejs.render(templateStore.get('booking/time-slot-item.ejs'), {
				time,
				endTime: add30Minutes(time),
				booked: isSlotBooked(selectedDate, time, add30Minutes(time), bookingStore.getBookings()),
				past: isSlotDisabled(selectedDate, time),
			});
			afternoon.insertAdjacentHTML('beforeend', html);
		});
	}
}

export function initRender() {
	renderDatePicker();
}
